module.exports = __webpack_public_path__ + "static/media/frietjes.f5cad5fc.jpg";